import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { BsXLg } from "react-icons/bs";
import "./style.css";

function CustomModal({ show, header, children, handleClose, size }) {
  return (
    <div>
      <Modal
        show={show}
        // backdrop="static"
        centered
        size={size ? size : "lg"}
        onHide={handleClose}
      >
        <Modal.Header>
          <span className="closeBtn" onClick={() => handleClose()}>
            {/* <span className="closeBtn"> */}
            <BsXLg />
          </span>
          <Modal.Title className="mx-auto">{header}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
      </Modal>
    </div>
  );
}

export default CustomModal;
